// @flow

export const FEATURES_LIST = {
  ACH: 'ach',
  BACKGROUD_CHECK_PAYMENTS: 'background_check_payments',
  AVALARA_TAXES: 'avalara_taxes',
}
